import { Admin } from "./components/admin-role/admin-role";
import { CompanyClockIn, CompanyPayCut, CompanyWorkingHour } from "./components/attendance-form/attendance";

export interface Company {
  name_th: string;
  name_en: string;
  tax_id: string;
  tax_branch: string;
  tax_branch_type: string;
  social_security_id: string;
  sso_branch: string;
  sso_business_code: string;
  sso_contribution_rate: number;
  email: string;
  phone_no: string;
  group_id: string;
  group_name: string;
  logo: string;
  id: string;
  signature_url: string;
  seal_url?: string;
  admin: Admin[];
  payment: Payment;
}

export interface Payment {
  detail: any[];
  installment: number;
}

export interface CompanyAddress {
  company_id: string;
  street_no: string;
  moo_no: string;
  building: string;
  room_no: string;
  floor_no: string;
  village_name: string;
  alley: string;
  lane: string;
  road: string;
  sub_district: string;
  district: string;
  province: string;
  postal_code: string;
  id: string;
  soi: string;
}

export interface CompanyBank {
  company_id: string;
  bank_id: string;
  bank_account_no: string;
  payment_method_id: string;
  payment_info: string;
  company_code: string;
  branch: string;
  id: string;
  transfer_info: TransferInfo;
}

export interface TransferInfo {
  to_other_bank: boolean;
  fee_type: string;
  employment_types: EmploymentType[];
}

export interface EmploymentType {
  employment_type: string;
  mcl: string;
}

export interface CompanyDetail {
  company: Company;
  company_address: CompanyAddress;
  company_bank: CompanyBank;
}

export interface CompanyAttendance {
  company_clock_in?: CompanyClockIn[]
  company_working_hours?: CompanyWorkingHour[]
  company_pay_cut?: CompanyPayCut[]
}

export enum Permission {
  // EditAdmin = 'EditAdmin',
  // EditEmployee = 'EditEmployee',
  // EditCompany = 'EditCompany',
  // DLStatement = 'DLStatement',
  // DLTax = 'DLTax',
  // DLSSO = 'DLSSO',
  // DLSlip = 'DLSlip',
  // DLReport = 'DLReport',
  // DLWht = 'DLWht',

  AccessEmployee = "Access_Employee",
  AccessPayroll = "Access_Payroll",
  AccessNotification = "Access_Notification",
  AccessAttendance = "Access_Attendance",
  AccessJob = "Access_Job",
  AccessSetting = "Access_Setting",

  DownloadBankTransfer = "Download_BankTransfer",
  DownloadPND = "Download_PND",
  DownloadSSO = "Download_SSO",
  DownloadReport = "Download_Report",

  ViewEmployeeSalary = "Other_ViewEmployeeSalary",
  ViewJobApplication = "Other_ViewJobApplication",
  EditEmployeeLeave = "Other_EditEmployeeLeave",
  EditAdminRole = "Other_EditAdminRole",
  EditCompanyInfo = "Other_EditCompanyInfo",
  EditCompanyAttendance = "Other_EditCompanyAttendance",
  EditCompanyHoliday = "Other_EditCompanyHoliday",
  EditPayroll = "Other_EditPayroll",
  EditEmployee = "Other_EditEmployee",
  AddEmployee = "Other_AddEmployee",
  ConfirmAttendance = "Other_ConfirmAttendance",

  CreateWorkingHour = "Other_CreateWorkingHour",
  CreateClockIn = "Other_CreateClockIn",
  CreateClockInGPSFacial = "Other_CreateClockInGPSFacial",
  CreatePayCut = "Other_CreatePayCut",
  EditWorkingHour = "Other_EditWorkingHour",
  EditClockIn = "Other_EditClockIn",
  EditPayCut = "Other_EditPayCut",
}

export const BranchTypes = [
  {id: 'vat', name: 'ภาษีมูลค่าเพิ่ม'},
  {id: 'specific', name: 'ภาษีธุรกิจเฉพาะ'},
  {id: 'none', name: 'ไม่มีประเภทสาขา'},
];

export interface Holiday {
  date: Date,
  description: string
}
